


// class Ga {
//     constructor() {}
//     init(){}
//     sendEvent(){}
//     sendPageView(){}
//     sendException(){}
//     sendSocialShare(){}
//     setDimension(){}
// }
import jsCookie from "js-cookie";
import {lowBrowser, createGUID } from './helper';
const PLATFORM  = 'reactm';
const VERSION   = `reactm-${process.env.SENTRY_RELEASE}`;
const GITHASH   = process.env.GITHASH;
const ENV       = window.YQ.configs.env;
const DEFAULTCONFIG = {
    // 跟踪器id
    gaId: null,
    // 采样率
    sampleRate: null,
    // 开发环境
    development: false,
    // 测试环境
    test: false,
    // 仿真环境
    release: true,
    // 生产环境
    production: true,
};

class Ga {
    constructor(config) {
        this.config = DEFAULTCONFIG;
        this.allowTheReport = false;
        // 将gtag衡量id传入全局变量
        this.gtagId = '';
    }

    
    /**
     *@Description: 初始化ga4(gtm.js)与noscript
    *@param {String} gtmId GTM-ga4媒体ID
    */
    initGtmGA(gtmId){
        // 初始化gtm.js
        try{
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer',gtmId);
        }catch(err){
        console.log(err);
        }

    // 创建gtm.js的noscript标签
        try {  
        (function(w,d,s,i){
            var _noscript = d.createElement(s[0]);
            var _iframe = d.createElement(s[1]);
            _iframe.src = 'https://www.googletagmanager.com/ns.html?id='+i;
            _iframe.width = 0;
            _iframe.height = 0;
            _iframe.style.display = 'none';
            _iframe.style.visibility = 'hidden';
            _noscript.appendChild(_iframe);
            if(d.body.childNodes[0]){
            d.body.insertBefore(_noscript,d.body.childNodes[0]);
            }else {
            d.body.appendChild(_noscript);
            }
        })(window,document,['noscript','iframe'],gtmId);
        }catch(err){
        console.log(err);
        }
    }

    /**
    *@Description: 初始化ga4(gtag.js)
    *@param {String} gtmId Gtag-ga4媒体ID
    *@param {Object} config Gtag-ga4 config 相关配置
    *@param {Boolean} globalTag Gtag-ga4 globalTag  全局收集ga4配置
    */
    initGtagGA(gtagId, config, globalTag){
        // 初始化gtag.js 
        try {
        // (() => {
        if (typeof window !== 'undefined') {
            (function (document, url) {
            var script = document.createElement('script');
            script.async = 1;
            script.src = url;
            var scriptFirstDom = document.getElementsByTagName('script')[0];
            scriptFirstDom.parentNode.insertBefore(script, scriptFirstDom)
            })(document, 'https://www.googletagmanager.com/gtag/js?id='+gtagId);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function() {
            try{
                dataLayer.push(arguments)
            }catch(e){
                console.log("GA-Error",e)
            }
            };
            window.gtag('js', new Date());

            // 把传入的gtagId保存到yqg4对象下，这样后续发送事件可以利用到
            this.gtagId =  this.gtagId || gtagId;
            // 如果只初始化全局衡量ID，自定义事件不发送统计过去
            if( this.gtagId === 'G-Y0R74VDYCP'){
                this.gtagId = '';
            }

            // 自定义维度1-页面
            var pageName = YQ && YQ.configs && YQ.configs.filePath || 'UNKNOW';
            

            var _defaultDimension = {
            'dimension1': pageName,
            'dimension2': window?.YQ.configs.lang, // 自定义维度2-页面词言
            'dimension3': lowBrowser(), // 自定义维度3-正常浏览器[normal]
            'dimension4': VERSION, // 自定义维度4-版本号
            'dimension5': '0', // 默认匿名维度,
            }

            // 判断是否需要添加配置，否则默认取消gtag的pv发送
            if(Object.prototype.toString.call(config) === '[object Object]'){ 
            // 合并传入配置与基础维度配置
            for( var key in config){
            _defaultDimension[key] = config[key];
            }
            }

            // 对于多个config衡量id而言，基础配置set配置使所有衡量id都将继承属性
            // 内嵌跨域标识
            window.gtag('set', 'cookie_flags', 'SameSite=None;Secure');
            // 设置登录用user_id，由于ga4的pv采用gtag自动发送，uid方面提前抽离方法设置
            this.setUserId();

            // 自定义参数配置gtag
            if(gtagId){
            window.gtag('config', gtagId, _defaultDimension);
            }

            // 全局数据添加
            if(globalTag){
            window.gtag('config', 'G-Y0R74VDYCP', {
                'location_global': window && window.location && window.location.pathname,
                ..._defaultDimension
                });
            }

            // 中国大陆
            if (YQ.country && YQ.country === 'CN') {
                window.gtag('config','G-6YXZP82DHM', {
                    'location_global': window && window.location && window.location.pathname,
                    ..._defaultDimension
                })
            }

            // seel的gtag
            window.gtag('config', 'G-2MMP7BWRGY', {
            'location_global': window && window.location && window.location.pathname,
            ..._defaultDimension
            });


        }
        // })(window,document,gtagId);
        } catch (e) {
        console.log(e);
        }

    }

    /**
    * Description: [sendGaEvent GA4事件跟踪: 此方法参数模拟原ga，
    * 由于GA4统计不再像以往GA会有 category、action、label概念与统计，此GA4参数需去后台单独设置维度统计
    * @param  {String} eventName   必须：[事件名称,Require]
    * @param  {Object}    value    非必须：[额外添加的事件]
    * @example
    * sendGaEvent('Seel保险-自动拒绝-咨询按钮',{'event_category':'123'});
    * sendGaEvent('YQinput-filter-结果页追踪');
    */
    sendGaEvent(eventName,value){
        // 修改ga4额外参数添加设置
        value = value || {};

        var _defaultDimension = {
        'send_to': this.gtagId
        }

        if(typeof window.gtag === 'function'){
            try{
                if(Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length !== 0){
                    // 合并传入配置与基础维度配置
                    for( var key in value){
                    _defaultDimension[key] = value[key];
                    }
                }

                window.gtag('event',eventName, _defaultDimension);
            
            }catch(err){
                console.log(err);
            }
        }
    }

    /**
     * 事件跟踪
     * @param {String} category 用户与之互动的对象
     * @param {String} action 互动的类型
     * @param {String} [label] 对事件进行分类（可选）
     * @param {Number} [value] 与事件相关的数值（可选）
     */
    sendEvent(category, action, label, value) {
        if (!this.allowTheReport) {
            return false;
        }

      // 用于传递ga4的parameter1
      var ga4Options = {};
      if(category){
          ga4Options.event_category = category;
      }
      if(action){
          ga4Options.event_action = action;
      }
      if(label){
          ga4Options.event_label = label;
      }
      if(value){
          ga4Options.value = value;
      }
        try {
            this.setLoginDimension();
        } catch (e) {
            console.log(e)
        }
        try{
            this.sendGaEvent( category+'-'+action,ga4Options)
        }catch(err){
            console.dir(err);
        }
    }

    /**
     * 用户计时统计
     * @param {String}  category 用于将所有用户计时变量归类到相应逻辑组的字符串
     * @param {String}  variable 用于标识要记录的变量的字符串
     * @param {Number}  [value] 向 Google Analytics（分析）报告的历时时间，以毫秒为单位（可选）
     * @param {String}  [label] 可用于提高报告中显示用户计时数据灵活性的字符串（可选）
     */
    sendTiming(category, variable, value, label) {
        if (!this.allowTheReport) {
            return false;
        }

      // 用于传递ga4的parameter1
      var ga4Options = {};
      if(category){
          ga4Options.event_category = category;
      }
      if(action){
          ga4Options.event_action = action;
      }
      if(label){
          ga4Options.event_label = label;
      }
      if(value){
          ga4Options.value = value;
      }

     try{
         this.setLoginDimension();
     }catch(err){
        console.dir(err);
     }

     try{
         this.sendGaEvent( category+'-'+variable,ga4Options)
     }catch(err){
         console.dir(err);
     }
    }

    /**
     * 上报错误
     * @param {any} stack 错误堆栈
     */
    sendException(errInfo) {
        if (!this.allowTheReport) {
            return false;
        }

        errInfo.md5 = GITHASH;
        errInfo.version = VERSION;
        errInfo.platform = PLATFORM;
        errInfo.env = ENV;

        if(typeof window.gtag === 'function'){
            try {
                window.gtag?.('event', 'exception', {
                'description': JSON.stringify(errInfo),
                'fatal': true  // set to true if the exception is fatal
                });
            } catch (e) {
                console.dir(`error: ga4 sendException error -> ${e}`)
            }
        }
    }

    /**
     * 分享（社交互动）
     * @param {String} network 发生操作的网络，例如wechat,facebook
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字
     */
    sendSocialShare(network, target) {
        this.sendSocial(network, 'share', target);
    }

    /**
     * 关注（社交互动）
     * @param {String} network 发生操作的网络，例如wechat,facebook
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字
     */
    sendSocialFollow(network, target) {
        this.sendSocial(network,'follow',  target);
    }

    /**
     * 社交互动
     * @param {String} socialNetwork 发生操作的社交平台，例如 wechat,facebook
     * @param {String} socialAction 发生的操作类型，例如 follow,share
     * @param {String} target 指定社交互动的目标。此值通常是网址，但也可以是任意文字。
     */
    sendSocial(socialNetwork = platform, socialAction, target) {
        if (!this.allowTheReport) {
            return false;
        }
        let socialTarget = target;
        // #ifdef H5
        socialTarget = location.href;
        // #endif
  
        // #ifndef H5
        const pages = getCurrentPages();
        const page = (pages[pages.length - 1] || {}).route;
        socialTarget = page;
        // #endif
  
        try {
            this.setLoginDimension();
        } catch (err) {
            console.dir(err);
        }
        if(typeof window.gtag === 'function'){
            try {
                window.gtag?.('event',socialAction,{
                    'event_category': "social",
                    'event_label': socialNetwork,
                    'event_action': socialAction,
                    'value': socialTarget,
                });
            } catch (err) {
                console.dir(err);
            }
        }
    }

    /**
     * 发送日志信息
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */
    sendLogInfo(action, msg) {
        this.sendLog('LogInfo', action, msg);
    }

    /**
     * 发送错误日志
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */
    sendLogError(action, msg) {
        this.sendLog('LogError', action, msg);
    }

    /**
     * 发送日志
     * @param {String} category 日志类型
     * @param {String} action 日志交互事件
     * @param {String} [msg] 日志描述（可选）
     */
    sendLog(category, action, msg) {
        if (!this.allowTheReport) {
            return false;
        }

      // 用于传递ga4的parameter1
      var ga4Options = {};
      if(action){
          ga4Options.event_action = action;
      }
      if(msg){
          ga4Options.event_action = msg;
      }

      try {
          this.setLoginDimension();
      } catch (e) {
          console.log(e);
      }

      try{
          this.sendGaEvent( "LogInfo",ga4Options);
      }catch(err){
          console.dir(err);
      }
    }

    /**
     * 设置自定义指标
     * @param {Number} index 0 < index < 21
     * @param {any} value 指标的值
     */
    setMetric(index, value) {
        if(typeof window.gtag === 'function'){
            try {
                window.gtag('set', 'metric' + index, value);
            } catch (err) {
                console.log(err);
            }
        }
    }

    /**
     * 设置自定义维度
     * @param {Number} index 0 < index < 21
     * @param {any} value 维度的值
     */
    setDimension(index, value) {
        if(typeof window.gtag === 'function'){
            try {
                window.gtag('set', 'dimension' + index, value);
            } catch (e) {
                console.log(e);
            }
        }
    }

    /**
     * seel业务设置自定义维度
     * @param {Number} index 0 < index < 21
     * @param {any} value 维度的值
     */
     setSeelDimension(index, value) {
        if(typeof window.gtag === 'function'){
            try {
                window.gtag('set', 'seel-dimension' + index, value);
            } catch (e) {
                console.log(e);
            }
        }
    }

    /**
     * seel业务事件跟踪
     * @param {String} category 用户与之互动的对象
     * @param {String} action 互动的类型
     * @param {String} [label] 对事件进行分类（可选）
     * @param {Number} [value] 与事件相关的数值（可选）
     */
     sendSeelEvent(category, action, label, value) {

        // 测试 seel 模块 GA事件追踪
        // if (!this.allowTheReport) {
        //     return false;
        // }

      // 用于传递ga4的parameter1
      var ga4Options = {};
      if(category){
          ga4Options.event_category = category;
      }
      if(action){
          ga4Options.event_action = action;
      }
      if(label){
          ga4Options.event_label = label;
      }
      if(value){
          ga4Options.value = value;
      }

      try {
          this.setLoginDimension();
      } catch (e) {
          console.dir('GA错误')
          console.dir(e)
      }

      if(typeof window.gtag === 'function'){
          try{
              window.gtag?.( category+'-'+action+'-'+label,{'send_to': 'G-2MMP7BWRGY', ...ga4Options})
          }catch(err){
              console.dir(err);
          }
      }  
    }

    // ga4设置用户登录角色user_id
    setUserId(){
        var _Ga4Uid = '';
        // 由于GA4的userId设置，并不是所有项目都需要，v3项目单独写在项目调用即可
        try {
            // 获取用户gid信息
            var loginInfo     = jsCookie.get('_yq_rc_'),
            guid           = createGUID(),//创建GUID
            guidName      = '_yq_bid',
            anonymityCode = jsCookie.get(guidName);//取当前cookie中的GUID
            //判断是否有设置GUID
            if(!anonymityCode || !(!!String(anonymityCode).trim())){
                //没有设置，把创建的GUID设置到cookie中，
                //过期时间为20年，天*年，365*20 = 7300
                jsCookie.set(
                    guidName,
                    guid,
                    {
                        domain  : '.17track.net',
                        expires : 7300,
                        path    : '/'
                    }
                );
                anonymityCode = guid;
            }
        
            if(loginInfo){
                var arrLoginInfo = loginInfo.split('.');
                var userRole = arrLoginInfo[5];
                var userGid = arrLoginInfo[6];
        
                if(userRole && userGid){
                _Ga4Uid = userGid;
                }else{
                    // 原来的cookie没有gid,统一强制删了这个cookie
                    jsCookie.remove('_yq_rc_', {domain: '.17track.net', path: '/' });
                }
            }else{
                //未登录
                _Ga4Uid = anonymityCode;
            }
        } catch (e) {
            console.log('gid>>>',e)
        }

        if(typeof window.gtag === 'function'){
            try{
                gtag('set', 'user_id', _Ga4Uid);
            }catch(err){
            console.log(err);
            }
        }

    }

    /**
     * 设置用户角度维度
     */
    setLoginDimension() {
        try {
            const loginInfo = jsCookie.get('_yq_rc_');
            const guidName = '_yq_bid';
            let anonymityCode = jsCookie.get(guidName);//取当前cookie中的GUID

            //判断是否有设置GUID
            if (!anonymityCode || !(!!String(anonymityCode).trim())) {
                const guid = createGUID(); //创建GUID
                jsCookie.set(
                    guidName,
                    guid,
                    {
                        domain: '.17track.net',
                        expires: 7300,
                        path: '/'
                    }
                );

                anonymityCode = guid;
            }

            if (loginInfo) {
                const arrLoginInfo = loginInfo.split('.');
                const userRole = arrLoginInfo[5];
                const userGid = arrLoginInfo[6];

                if (userRole && userGid) {
                    // 设置用户角色
                    this.setDimension(5, userRole);
                    // 设置用户Id
                    this.setUser(userGid);
                } else {
                    // 原来的cookie没有gid,统一强制删了这个cookie
                    jsCookie.remove('_yq_rc_', {domain: '.17track.net', path: '/'});
                }
            } else {
                //未登录
                this.setUser(anonymityCode);
            }
        } catch (e) {
            console.log(e);
        }
    }
}




export default new Ga();
